var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.selected,"placeholder":_vm.plc || 'paid_price',"size":_vm.size,"filterable":"","clearable":""},on:{"input":_vm.dispatch}},_vm._l((_vm.inventory),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }